import { FC } from "react";
import { CompleteSignUp } from "../../../../modules/authentication/components/complete-sign-up/complete-sign-up";
import { useQuery } from "../../../../modules/common/hooks/use-query/use-query";

export const CompleteSignUpRoute: FC = () => {

    // router hooks
    const { securityToken } = useQuery() as { securityToken: string }
    const decodedSecurityToken = atob(securityToken)

    return (
        <CompleteSignUp
            securityToken={decodedSecurityToken}
        />
    )
}